const DEFAULT_FILTER_VALUE = ''

export default DEFAULT_FILTER_VALUE
